<template>
  <b-container class="mt-2 custom-padding">
    <b-row align-v="center" class="justify-content-end">
      <b-col class="input-search" sm="4" md="6" lg="4">
        <b-input-group>
          <template v-slot:prepend>
            <b-input-group-text class="iconPesquisa">
              <b-icon-search></b-icon-search>
            </b-input-group-text>
          </template>
          <b-form-input
            trim
            class="barraPesquisa"
            autocomplete="off"
            placeholder="Pesquisar"
            v-model="searchText"
          />
        </b-input-group>
      </b-col>
    </b-row>
    <b-row align-h="end">
      <b-col class="table-margin">
        <b-table
          hover
          bordered
          class="mt-2 table"
          id="my-table-members"
          :items="items"
          :fields="fields"
          :filter="searchText"
        >
          <!-- Primeira coluna, coluna das quantidades -->
          <template v-slot:cell(integrantes )>
            <div>
              <span id="input-amount"></span>
            </div>
          </template>

          <!-- Ultima coluna, coluna dos icones  -->
          <template v-slot:head(buttons) class="h-25">
            <a
              @click="alertButton"
              v-bind:disabled="isButtonDisabled"
              v-b-modal.addIntegrante
              style="margin-left: 15px"
            >
              <b-icon-plus class="icons" scale="2" />
            </a>
          </template>

          <template v-slot:cell(buttons)="data" class="botoes h-25">
            <div class="div-itens">
              <a
                @click="editMember(data.item._id)"
                style="margin-right: 1rem; margin-top: 1rem"
              >
                <b-icon-pencil class="icons" scale="1"></b-icon-pencil>
              </a>

              <a style="margin-top: 1rem">
                <b-icon-trash
                  class="icons"
                  scale="1"
                  @click="deletar(data.item._id)"
                ></b-icon-trash>
              </a>
            </div>
          </template>
        </b-table>
      </b-col>
    </b-row>

    <ModalMembers idModal="addIntegrante" :funcaoRefresh="atualizarAdd" />
    <ModalMembers
      edit
      idModal="editIntegrante"
      :funcaoRefresh="atualizarEdit"
      :idEdit="id"
    />
    <PopupConfirmacao
      id_modal="deletar"
      cor_imagem="#E2574C"
      titulo="Atenção"
      texto="Deseja realmente excluir esse integrante?"
      texto_botao1="Continuar"
      cor_botao1="#FFFFFF"
      cor_background_botao1="#EB5353"
      hover_botao1="#a53a36"
      texto_botao2="Cancelar"
      cor_botao2="#FFFFFF"
      cor_background_botao2="#ADADAD"
      hover_botao2="#8b8b8b"
      :confirma_acao="okDeletar"
    />
    <ModalAlert
      idModal="excluido"
      msg="Integrante deletado com sucesso!"
      colorFont="green"
    />
    <ModalAlert
      idModal="editado"
      msg="Integrante editado com sucesso!"
      colorFont="green"
    />
    <ModalAlert
      idModal="adicionado"
      msg="Integrante adicionado com sucesso!"
      colorFont="green"
    />
    <ModalAlert
      idModal="alertMembers"
      msg="Atenção! Já foram adicionadas 10 pessoas a equipe e este é o limite!"
      colorFont="#343842"
    />
  </b-container>
</template>

<style lang="scss" scoped>
@media (max-width: 1700px) {
  .custom-padding {
    padding-right: 1rem;
  }
}
@media (max-width: 700px) {
  .custom-padding {
    padding-right: 0.5rem;
    padding-left: 5rem;
  }
  .input-search {
    width: 12rem;
  }
}
</style>

<style lang="scss">
.custom-padding {
  #invt-modal .modal-header,
  #invt-modal .modal-footer {
    display: none;
  }
  .question {
    text-align: left;
    font-weight: 300;
    border-right: 3px solid #343842 !important;
  }

  .th-question {
    width: 20rem;
    border-bottom: 3px solid #343842 !important;
    border-right: 3px solid #343842 !important;
    text-align: left;
  }

  .people {
    text-align: left;
    font-weight: 300;
    padding-top: 0.7rem !important;
    padding-bottom: 0.7rem !important;
  }

  .th-people {
    border-bottom: 3px solid #343842 !important;
    text-align: left;
  }

  .th-buttons {
    width: 2rem;
    border-left-style: hidden !important;
    border-bottom: 3px solid #343842 !important;
  }

  .buttons {
    padding: unset !important;
    border-left-style: hidden !important;
  }

  .div-itens {
    width: 100%;
    height: 100%;
    display: flex;
    vertical-align: middle;
    align-items: center;
    align-content: center;
    justify-content: center;
    margin-top: -0.3rem !important;
  }

  .icons {
    color: #000;
  }
  .icons:hover {
    color: #343842 !important;
  }
  .pagination .page-link,
  .pagination .page-link:hover {
    color: #343842;
  }
  .pagination .page-item.active .page-link {
    background-color: #343842;
    color: #e5e5e5;
  }
  .pagination .page-item.active .page-link:hover {
    color: #e5e5e5;
  }

  .row-hidden {
    display: none;
  }
  @media (max-width: 540px) and (min-width: 540px) {
    #my-table-members {
      width: 90%;
    }
    .barraPesquisa {
      margin-right: 3rem !important;
    }
    .iconPesquisa {
      margin-left: -2rem;
    }
  }
  @media (max-width: 320px) {
    .custom-padding {
      padding-left: 4.5rem;
    }
  }
}
</style>

<script>
import { getMembers, deleteMember } from '@/services/api/Members';
import ModalMembers from '@/components/dashboard/ModalMembers.vue';
import PopupConfirmacao from '@/components/dashboard/PopupConfirmacao.vue';
import ModalAlert from '@/components/dashboard/ModalAlert.vue';
export default {
  components: { ModalMembers, PopupConfirmacao, ModalAlert },
  name: 'TabelaEquipe',
  data() {
    return {
      searchText: '',
      id: '',
      isButtonDisabled: false,

      fields: [
        {
          key: 'name',
          label: 'Integrantes',
          tdClass: 'people',
          thClass: 'th-people',
        },
        {
          key: 'buttons',
          label: '',
          tdClass: 'buttons',
          thClass: 'th-buttons',
        },
      ],
      items: [],
    };
  },
  methods: {
    alertButton() {
      if (this.isButtonDisabled === true) {
        this.$root.$emit('bv::show::modal', 'alertMembers');
        setTimeout(() => {
          this.$root.$emit('bv::hide::modal', 'alertMembers');
        }, 4000);
      }
    },
    deletar(id) {
      this.id = id;

      this.$root.$emit('bv::show::modal', 'deletar');
    },
    okDeletar() {
      this.$root.$emit('bv::hide::modal', 'deletar');
      deleteMember(this.id)
        .then(() => {
          this.atualizar();
          this.$root.$emit('bv::show::modal', 'excluido');
          setTimeout(() => {
            this.$root.$emit('bv::hide::modal', 'excluido');
          }, 2000);
        })
        .catch(() => {
          this.$bvToast.toast(
            'Erro ao deletar membro, recarregue a página e tente novamente. Caso persista, tente novamente mais tarde.',
            {
              title: 'Erro ao deletar membro',
              autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
              variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
            },
          );
        });
    },
    editMember(id) {
      this.id = id;

      setTimeout(() => {
        this.$root.$emit('bv::show::modal', 'editIntegrante');
      }, 50);
    },
    atualizar() {
      this.receberDados();
      this.$root.$emit('bv::refresh::table', 'my-table-members');
    },
    atualizarEdit() {
      this.atualizar();
      this.$root.$emit('bv::show::modal', 'editado');
      setTimeout(() => {
        this.$root.$emit('bv::hide::modal', 'editado');
      }, 2000);
    },
    atualizarAdd() {
      this.atualizar();
      this.$root.$emit('bv::show::modal', 'adicionado');
      setTimeout(() => {
        this.$root.$emit('bv::hide::modal', 'adicionado');
      }, 2000);
    },
    receberDados() {
      getMembers()
        .then((res) => {
          this.items = res.data;
          if (this.rows === 10) {
            this.isButtonDisabled = true;
          } else {
            this.isButtonDisabled = false;
          }
        })
        .catch(() => {
          this.$bvToast.toast(
            'Erro interno no servidor, recarregue a página. Caso persista, tente novamente mais tarde.',
            {
              title: 'Erro interno no servidor',
              autoHideDelay: 5000, //Tempo em milissegundos para o toast desaparecer
              variant: 'danger', //Danger é a variante vermelha. Variantes: default, primary, secondary, danger,warning, success e info
            },
          );
        });
    },
  },
  computed: {
    rows() {
      return this.items.length;
    },
  },
  mounted() {
    this.receberDados();
  },
};
</script>
